import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1.5">
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-xs font-bold text-white">
          <i className="ri-star-fill" aria-hidden="true"></i>
          {comic.score.toFixed(1)}
        </span>
        <span className="absolute bottom-3 right-3 inline-flex rounded-full bg-black/55 px-2.5 py-1 text-xs text-white backdrop-blur-sm">
          {comic.chapter}
        </span>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-lg text-foreground-950">{comic.title}</h3>
        <p className="mt-0.5 text-xs text-foreground-500">
          {comic.author} · {comic.status}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {comic.tags.map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {comic.description}
        </p>
        <button
          type="button"
          className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-4 py-2 text-sm text-white transition-colors hover:bg-primary-600"
        >
          开始阅读
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </button>
      </div>
    </article>
  );
}